import _ from 'lodash';
import $ from 'jquery';
import FormUtil from 'edge/platform/modelvalidation/FormUtil';

var dependentCoverages = [];
var opsInSequence = void 0;

function getDependentCoverages() {
    return dependentCoverages;
}

function getDependentCoveragesForLOB(CoverageService, jobNumber) {
    return CoverageService.getDependentCoveragesForLob(jobNumber).then(function (depCovs) {
        dependentCoverages = depCovs;

        return depCovs;
    });
}

function getSequencer() {
    opsInSequence = [$.Deferred().resolve()];
    return resolveRequestInSequence;
}

function updateDependentCoverages(coverages, covsToUpdate) {
    var depLOBCoverages = _.filter(coverages, function (coverage) {
        return _.find(dependentCoverages, function (depCov) {
            return depCov.name === coverage.publicID || depCov.dependencies.includes(coverage.publicID);
        });
    });

    _.each(covsToUpdate, function (coverage) {
        coverage = _.find(depLOBCoverages, { publicID: coverage.publicID }) || coverage;

        return coverage;
    });
}

function updateCoverages(updatedCoverage, coverages, covsToUpdate) {
    var updatedCoverages = coverages;
    if (updatedCoverage) {
        var updatedDependentCov = _.find(dependentCoverages, function (depCov) {
            return depCov.name === updatedCoverage.publicID || _.find(updatedCoverage.terms, { type: depCov.name });
        });
        if (updatedDependentCov) {
            updatedCoverages = _.filter(coverages, function (coverage) {
                return updatedDependentCov.name === coverage.publicID || updatedDependentCov.dependencies.includes(coverage.publicID);
            });
        } else {
            var cov = _.find(updatedCoverages, { publicID: updatedCoverage.publicID });

            if (cov) {
                updatedCoverages = [cov];
            }
        }
    }

    // Remove any coverage that the server has made unavailable
    _.remove(covsToUpdate, function (cov) {
        return !_.find(coverages, { publicID: cov.publicID });
    });

    // Add any coverages that the server has made available
    _.each(coverages, function (cov, i) {
        if (!_.find(covsToUpdate, { publicID: cov.publicID })) {
            covsToUpdate.splice(i, 0, cov);
        }
    });

    return _.each(covsToUpdate, function (coverage, i) {
        coverage = _.find(updatedCoverages, { publicID: coverage.publicID }) || coverage;

        covsToUpdate.splice(i, 1, coverage);
        return coverage;
    });
}

function resolveRequestInSequence(operation) {
    var lastOpInSequence = _.last(opsInSequence);
    var sequencedOp = operation.then(function (res) {
        return lastOpInSequence.then(function () {
            return res;
        });
    }); // Force resolve in sequence

    opsInSequence.push(sequencedOp);

    return sequencedOp;
}

function validateForm(form) {
    if (form) {
        FormUtil.markFormsSubmitted(form);

        if (!form.valid) {
            if (form.invalidInputs[0]) {
                $('html, body').animate({
                    scrollTop: $('#' + form.invalidInputs[0]).offset().top - 10 // offset by 10px
                }, 300);
            }

            return false;
        }
    }

    return true;
}

export default (function () {

    return {
        getDependentCoverages: getDependentCoverages,
        getDependentCoveragesForLOB: getDependentCoveragesForLOB,
        updateCoverages: updateCoverages,
        updateDependentCoverages: updateDependentCoverages,
        getSequencer: getSequencer,
        validateForm: validateForm
    };
});


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/policycommon/common/util/CoveragesUtil.js
// module id = 807
// module chunks = 0